import { FC } from 'react';
import clsx from 'clsx';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.css';

const minLength = 12;
const hasLength = (input: string): boolean => input.length >= minLength;
const hasUppercase = (input: string): boolean => /[A-Z]/g.test(input);
const hasLowercase = (input: string): boolean => /[a-z]/g.test(input);
const hasSymbol = (input: string): boolean => /[^a-zA-Z0-9]/g.test(input);

export function isValidPassword(input: string): boolean {
  return hasLength(input) && hasUppercase(input) && hasLowercase(input) && hasSymbol(input);
}

const PasswordHints: FC<{ pass: string }> = (props) => {

  const { pass } = props;

  const getErrorState = (isValid: boolean): string => {

    // if there's no value yet, we ignore the error state
    if (pass.length === 0)
      return styles.default;

    if (isValid)
      return styles.success;

    return styles.error;

  };

  const getIcon = (isValid: boolean) => {

    // if there's no value yet, show info
    if (pass.length === 0)
      return faInfoCircle as IconProp;

    if (isValid)
      return faCheckCircle as IconProp;

    return faTimesCircle as IconProp;

  };

  return (
    <div className={styles.hints}>
      <div className={styles.hint}>
        <FontAwesomeIcon
          icon={getIcon(hasLength(pass))}
          className={clsx(styles.icon, getErrorState(hasLength(pass)))}
        />
        <span>At least {minLength} characters in length</span>
      </div>
      <div className={styles.hint}>
        <FontAwesomeIcon
          icon={getIcon(hasUppercase(pass))}
          className={clsx(styles.icon, getErrorState(hasUppercase(pass)))}
        />
        <span>Has at least one UPPERCASE letter</span>
      </div>
      <div className={styles.hint}>
        <FontAwesomeIcon
          icon={getIcon(hasLowercase(pass))}
          className={clsx(styles.icon, getErrorState(hasLowercase(pass)))}
        />
        <span>Has at least one lowercase letter</span>
      </div>
      <div className={styles.hint}>
        <FontAwesomeIcon
          icon={getIcon(hasSymbol(pass))}
          className={clsx(styles.icon, getErrorState(hasSymbol(pass)))}
        />
        <span>Has at least one symbol</span>
      </div>
    </div>
  );

};

export default PasswordHints;
